import { combineReducers } from 'redux';

import activeDimensionsReducer from './active_dimensions/reducer';
import appConfigReducer from './app_config/reducer';
import { imageError, imageState } from './company/reducers';
import dashboardReducer from './dashboard/reducer';
import messengerReducer from './messenger/reducer';
import scheduleConfigReducer from './schedule_config/reducer';
import secondAsideReducer from './second_aside/reducer';
import selectedIdsReducer from './selected_ids/reducer';
import selectedViewsReducer from './selected_view/reducer';
import styleGuideReducer from './style_guide/reducer';
import taskReducer from './task/reducer';

export default combineReducers({
  activeDimensions: activeDimensionsReducer,
  appConfig: appConfigReducer,
  company: combineReducers({
    imageError,
    imageState,
  }),
  dashboard: dashboardReducer,
  messenger: messengerReducer,
  scheduleConfig: scheduleConfigReducer,
  secondAside: secondAsideReducer,
  selectedIds: selectedIdsReducer,
  selectedViews: selectedViewsReducer,
  styleGuide: styleGuideReducer,
  task: taskReducer,
});
